import { calculateWheelSize, WheelSize } from "@/lib/wheelSize";

const referenceSizes = [
  "155/70R13", "165/65R13", "185/60R13", "155/80R13", "175/65R13", "175/70R13", "185/65R13", "165/80R13", "185/70R13", "175/80R13",
  "155/65R14", "175/60R14", "185/55R14", "195/50R14", "165/70R14", "175/65R14", "185/60R14", "175/70R14", "185/65R14", "195/65R14", "205/70R14",
  "165/60R15", "175/55R15", "185/50R15", "195/45R15", "185/55R15", "185/60R15", "195/55R15", "205/55R15", "185/65R15", "195/65R15", "215/65R15",
  "175/50R16", "185/50R16", "195/45R16", "205/50R16", "205/55R16", "215/55R16", "225/50R16", "225/55R16", "235/60R16", "245/70R16", "265/70R16",
  "205/40R17", "205/45R17", "215/45R17", "225/45R17", "225/50R17", "235/45R17", "225/55R17", "235/55R17", "245/65R17", "265/65R17", "285/70R17",
  "205/35R18", "215/40R18", "225/40R18", "235/40R18", "245/40R18", "235/45R18", "225/55R18", "235/60R18", "255/55R18", "265/60R18",
  "225/35R19", "235/35R19", "245/35R19", "245/40R19", "255/40R19", "235/50R19", "255/50R19", "275/45R19",
  "225/35R20", "245/35R20", "255/35R20", "245/40R20", "255/45R20", "265/50R20", "275/55R20",
  "245/35R21", "255/35R21", "265/40R21", "275/40R21", "285/45R21",
  "255/30R22", "265/35R22", "285/35R22", "275/40R22", "285/45R22",
];

export const TYRE_CHART_SIZES = referenceSizes.map((label) => {
  const [width, aspectRatio, rimDiameter] = label.split(/[/R]/).map(Number);
  const size: WheelSize = { width, aspectRatio, rimDiameter };
  const specs = calculateWheelSize(size);
  return { label, size, ...specs, diameterInches: specs.diameter / 25.4, diameterGroup: Math.round(specs.diameter / 25.4) };
});

export type TyreChartEntry = typeof TYRE_CHART_SIZES[number];

export function groupTyreChartSizes(entries: TyreChartEntry[], by: "diameter" | "wheel") {
  const groups = new Map<number, TyreChartEntry[]>();
  for (const entry of entries) {
    const key = by === "diameter" ? entry.diameterGroup : entry.size.rimDiameter;
    const group = groups.get(key) ?? [];
    group.push(entry);
    groups.set(key, group);
  }
  return [...groups.entries()].sort(([a], [b]) => a - b);
}
